import React from 'react'

const Logo = ({size,classes}) => (
    <div className={`icon logo logo-${size} ${classes}`}>
      Digitus
    </div>
)

export default Logo
